module.exports = __webpack_public_path__ + "img/banner-principal-decorativo-2.51b681c1.svg";